import { FC } from 'react'

import { RadioGroup } from 'ui/components'
import { TextareaInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { MainText, SecondText } from '../../style'
import { ReviewDepositLogProps } from './ReviewDepositLogProps'

export const ReviewDepositLog: FC<ReviewDepositLogProps> = ({ Field }) => (
  <>
    <FormRow>
      <Col2x>
        <MainText>
          Deposits by third parties with no apparent connection to the accountholder.
          <br />
          Individuals conducting transactions for the business appear to be acting on behalf of other, undisclosed
          parties of interest.
        </MainText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col>
        <SecondText>
          Review Deposit Log for name and occupation for person conducting the deposit transaction.
        </SecondText>
      </Col>
      <Col>
        <Field
          name="reviewDepositLogRedFlag"
          input={RadioGroup}
          inputProps={{
            data: [
              {
                label: 'Yes',
                value: 'yes'
              },
              {
                label: 'No',
                value: 'no'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewDepositLogWhoMakesDeposits"
          label="Who makes deposits for the business?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'Owner',
                value: 'owner'
              },
              {
                label: 'Employee',
                value: 'employee'
              },
              {
                label: 'Courier',
                value: 'courier'
              },
              {
                label: 'Mobile Deposit',
                value: 'mobile_deposit'
              },
              {
                label: 'No Transactions of this Type',
                value: 'no_transactions'
              },
              {
                label: 'Other – See comments',
                value: 'other'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col2x>
        <Field
          name="reviewDepositLogComments"
          label="Comments"
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
